import moment from 'moment';

export default class UserService {
  static getInvestorId() {
    const stored = localStorage.getItem('Hub8020_investor_id');
    return stored || null;
  }

  static getCurrentDealFlow() {
    return localStorage.getItem('Hub8020_current_deal_flow')
      ? JSON.parse(localStorage.getItem('Hub8020_current_deal_flow'))
      : null;
  }

  static getCurrentTermSheetId() {
    return localStorage.getItem('Hub8020_current_term_sheet_id')
      ? JSON.parse(localStorage.getItem('Hub8020_current_term_sheet_id'))
      : null;
  }

  static getCurrentPage() {
    return localStorage.getItem('Hub8020_deal_flow_current_page')
      ? JSON.parse(localStorage.getItem('Hub8020_deal_flow_current_page'))
      : null;
  }

  static getToken() {
    return localStorage.getItem('Hub8020_token');
  }

  static getUserInfo() {
    return localStorage.getItem('Hub8020_user') !== 'undefined'
      ? JSON.parse(localStorage.getItem('Hub8020_user'))
      : null;
  }

  static getUserSubscriptionInfo() {
    return localStorage.getItem('Hub8020_user_subscription_info') !==
      'undefined'
      ? JSON.parse(localStorage.getItem('Hub8020_user_subscription_info'))
      : null;
  }

  static getUserSubscriptionPlans() {
    return localStorage.getItem('Hub8020_user_subscription_plans') !== 'undefined'
      ? JSON.parse(localStorage.getItem('Hub8020_user_subscription_plans'))
      : null;
  }

  static setUserSubscriptionPlans(plans) {
    localStorage.setItem('Hub8020_user_subscription_plans', JSON.stringify(plans));
  }

  static getCompanyInfo() {
    return localStorage.getItem('Hub8020_company') !== 'undefined'
      ? JSON.parse(localStorage.getItem('Hub8020_company'))
      : null;
  }

  static getAllCompaniesInfo() {
    return localStorage.getItem('Hub8020_all_companies') !== 'undefined'
      ? JSON.parse(localStorage.getItem('Hub8020_all_companies'))
      : null;
  }

  static getExpertInfo() {
    const expertInfo = localStorage.getItem('Hub8020_expert');
    if (expertInfo && expertInfo !== 'undefined') {
      return JSON.parse(expertInfo);
    } else {
      return null;
    }
  }

  static getNotificationCurrentCount() {
    return localStorage.getItem('Hub8020_notification_current_count')
      ? JSON.parse(localStorage.getItem('Hub8020_notification_current_count'))
      : 0;
  }

  static setNotificationCurrentCount(count) {
    localStorage.setItem(
      'Hub8020_notification_current_count',
      JSON.stringify(count),
    );
  }

  static getUnreadMessages() {
    return localStorage.getItem('Hub8020_unread_messages')
      ? JSON.parse(localStorage.getItem('Hub8020_unread_messages'))
      : null;
  }

  static setUnreadMessages(connection) {
    localStorage.setItem(
      'Hub8020__unread_messages',
      JSON.stringify(connection),
    );
  }

  static setCurrentDealFlow(dealFlow) {
    localStorage.setItem('Hub8020_current_deal_flow', JSON.stringify(dealFlow));
  }

  static setCurrentPage(page) {
    localStorage.setItem(
      'Hub8020_deal_flow_current_page',
      JSON.stringify(page),
    );
  }

  static setCurrentTermSheetId(id) {
    localStorage.setItem('Hub8020_current_term_sheet_id', JSON.stringify(id));
  }

  static setToken(token) {
    localStorage.setItem('Hub8020_token', token);
  }

  static setUserInfo(user) {
    localStorage.setItem('Hub8020_user', JSON.stringify(user));
  }

  static setUserSubscriptionInfo(info) {
    localStorage.setItem(
      'Hub8020_user_subscription_info',
      JSON.stringify(info),
    );
  }

  static setCompanyInfo(company) {
    localStorage.setItem('Hub8020_company', JSON.stringify(company));
  }

  static setInvestorId(investorId) {
    if (investorId) {
      localStorage.setItem('Hub8020_investor_id', investorId);
    }
  }


  static setTimeSlotPromptDismissed() {
    localStorage.setItem(
      'Hub8020_time_slot_prompt_dismissed',
      Date.now().toString(),
    );
  }

  // Termsheet notification methods
  static setTermsheetNotificationSnoozed() {
    localStorage.setItem(
      'Hub8020_termsheet_notification_snoozed',
      Date.now().toString(),
    );
  }

  static getTermsheetNotificationSnoozed() {
    return localStorage.getItem('Hub8020_termsheet_notification_snoozed');
  }

  static setTermsheetNotificationDismissed(dismissed) {
    localStorage.setItem('Hub8020_termsheet_notification_dismissed', dismissed);
  }

  static getTermsheetNotificationDismissed() {
    return localStorage.getItem('Hub8020_termsheet_notification_dismissed');
  }

  static removeTermsheetNotificationSnoozed() {
    localStorage.removeItem('Hub8020_termsheet_notification_snoozed');
  }

  static removeTermsheetNotificationDismissed() {
    localStorage.removeItem('Hub8020_termsheet_notification_dismissed');
  }

  static setAllCompaniesInfo(company) {
    localStorage.setItem('Hub8020_all_companies', JSON.stringify(company));
  }

  static setExpertInfo(expert) {
    localStorage.setItem('Hub8020_expert', JSON.stringify(expert));
  }

  static removeNotificationCurrentCount() {
    localStorage.removeItem('Hub8020_notification_current_count');
  }

  static removeCurrentDealFlow() {
    localStorage.removeItem('Hub8020_current_deal_flow');
  }

  static removeCurrentTermSheetId() {
    localStorage.removeItem('Hub8020_current_term_sheet_id');
  }

  static removeCurrentPage() {
    localStorage.removeItem('Hub8020_deal_flow_current_page');
  }

  static removeToken() {
    localStorage.removeItem('Hub8020_token');
  }

  static removeUserInfo() {
    localStorage.removeItem('Hub8020_user');
  }

  static removeCompanyInfo() {
    localStorage.removeItem('Hub8020_company');
  }

  static removeInvestorId() {
    localStorage.removeItem('Hub8020_investor_id');
  }

  static removeAllCompaniesInfo() {
    localStorage.removeItem('Hub8020_all_companies');
  }

  static removeExpertInfo() {
    localStorage.removeItem('Hub8020_expert');
  }

  static removeTimeSlotPromptDismissed() {
    localStorage.removeItem('Hub8020_time_slot_prompt_dismissed');
  }

  static getTimeSlotPromptDismissed() {
    return localStorage.getItem('Hub8020_time_slot_prompt_dismissed');
  }

  static removeUserSubscriptionInfo() {
    localStorage.removeItem('Hub8020_user_subscription_info');
  }

  static clearCredentials() {
    localStorage.clear();
  }

  static getCompleteSurveyAction() {
    return localStorage.getItem('Hub8020_complete_survey_action')
      ? localStorage.getItem('Hub8020_complete_survey_action')
      : false;
  }

  static setCompleteSurveyAction(action) {
    localStorage.setItem('Hub8020_complete_survey_action', action);
  }
}
